import mitt from 'mitt';

if (globalThis.window) {
  (window as any).__EMITTER__ = mitt();
}
